import type { JSX } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
}

export const CustomSportsGolf = ({ color, opacity = '1', fillOpacity = '1', size = 20 }: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} viewBox="0 0 20 20">
        <path
            d="M16.2502 17.5001C15.9029 17.5001 15.6078 17.3786 15.3647 17.1355C15.1217 16.8924 15.0002 16.5973 15.0002 16.2501C15.0002 15.9029 15.1217 15.6077 15.3647 15.3647C15.6078 15.1216 15.9029 15.0001 16.2502 15.0001C16.5974 15.0001 16.8925 15.1216 17.1356 15.3647C17.3786 15.6077 17.5002 15.9029 17.5002 16.2501C17.5002 16.5973 17.3786 16.8924 17.1356 17.1355C16.8925 17.3786 16.5974 17.5001 16.2502 17.5001ZM8.3335 18.3334C6.94461 18.3334 5.76405 18.1702 4.79183 17.8438C3.81961 17.5174 3.3335 17.1251 3.3335 16.6667C3.3335 16.3473 3.56266 16.0626 4.021 15.8126C4.47933 15.5626 5.0835 15.3612 5.8335 15.2084V16.6667H7.50016V1.66675L14.1668 4.91675L9.16683 7.50008V15.0417C10.3613 15.1112 11.3543 15.2952 12.146 15.5938C12.9377 15.8924 13.3335 16.2501 13.3335 16.6667C13.3335 17.1251 12.8474 17.5174 11.8752 17.8438C10.9029 18.1702 9.72239 18.3334 8.3335 18.3334Z"
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
